import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingSupportWidgetComponent } from './floatingSupportWidget.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  declarations: [FloatingSupportWidgetComponent],
  exports: [FloatingSupportWidgetComponent]
})
export class FloatingSupportWidgetModule { }
